import { toast } from '@hivebrite/design-system/Toast';

import {
  COMMENTS_PER_PAGE,
  SORT_BY,
} from 'hb-react/frontoffice/apps/CommentsV2/constants';
import {
  type GetCommentsParams,
  type GetCommentsResponse,
  type PageParamType,
} from 'hb-react/frontoffice/apps/CommentsV2/types';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import { configToSnakeCase } from 'hb-react/shared/utils/axiosInterceptors';

export const getComments = async ({
  userId,
  params,
  pageParam,
  signal,
}: {
  pageParam?: PageParamType;
  params: GetCommentsParams;
  signal?: AbortSignal;
  userId: number;
}) => {
  const url = Routes.user_comments_path(userId);
  const {
    order = 'desc',
    limit = COMMENTS_PER_PAGE,
    sortBy = SORT_BY.RECENT,
  } = params;

  try {
    const response = await axios.get<GetCommentsResponse>(
      url,
      configToSnakeCase({
        params: {
          ...params,
          order,
          limit,
          sortBy,
          ...pageParam,
        },
        signal,
      }),
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      toast.error(s__('Comments|Sorry, the referred comment is not available'));
    } else {
      toast.error(__('Sorry, an error occurred'));
    }

    throw error;
  }
};
